import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=49ed946a&scoped=true&"
import script from "./BottomMenu.vue?vue&type=script&lang=js&"
export * from "./BottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=49ed946a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed946a",
  null
  
)

export default component.exports